// extracted by mini-css-extract-plugin
var _1 = "tKyumRh1r_r6MH2dxAsb";
var _2 = "p3bl6cx60YDUJMMYCRk_";
export { _1 as "heading", _2 as "wrapper" }
